import { Link } from "react-router-dom";
import { UserPlus, CheckCircle } from "lucide-react";

/**
 * AccountBenefitsPanel — optional CTA rendered under the guest checkout form.
 * Visually secondary to the primary Continue-to-Payment button. Never a popup.
 */
const BENEFITS = [
  "View trip history",
  "Rebook previous rides instantly",
  "Save pickup locations",
  "Save airport preferences",
  "Save passenger information",
  "Faster checkout",
  "Download invoices",
  "Track upcoming rides",
  "Store favourite destinations",
  "Corporate travel management",
  "Manage multiple reservations",
  "Future rewards program eligibility",
];

export default function AccountBenefitsPanel() {
  return (
    <aside
      data-testid="account-benefits-panel"
      className="mt-8 border border-white/10 bg-[#0B0B0C]/60 px-5 md:px-6 py-6"
    >
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.32em] text-[#C5A24A] mb-2">
        <UserPlus size={12} strokeWidth={1.5} /> Optional
      </div>
      <h4 className="font-serif text-lg text-white tracking-tight mb-3">
        Create a Free Account
      </h4>
      <p className="text-sm text-[#8E9AA6] font-light leading-relaxed mb-4">
        Your booking is already going through — creating an account is optional. If you'd
        like the extras below on your next reservation, it takes about 30 seconds.
      </p>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 text-xs text-[#E6E6E6]/80 font-light mb-5">
        {BENEFITS.map((b) => (
          <li key={b} className="flex items-start gap-2 leading-snug">
            <CheckCircle size={11} strokeWidth={1.5} className="text-[#C5A24A] shrink-0 mt-0.5" />
            <span>{b}</span>
          </li>
        ))}
      </ul>
      <Link
        to="/register?return=/book"
        data-testid="account-benefits-cta"
        className="inline-flex items-center gap-2 border border-[#C5A24A]/50 text-[#C5A24A] hover:bg-[#C5A24A] hover:text-black px-5 py-3 text-[10.5px] uppercase tracking-[0.28em] transition-colors"
      >
        Create Account (Optional)
      </Link>
    </aside>
  );
}
